export function keySet<Obj extends Record<string, any>>(
  obj: Obj
): Set<keyof Obj> {
  let keySet = new Set<keyof Obj>();
  let key: keyof Obj | undefined;
  for (key in obj) {
    keySet.add(key);
  }
  return keySet;
}
